/**
 * @generated SignedSource<<34a43fbceae2db6a500232402e20fe47>>
 * @relayHash 325893057a9ae854264a36ff297497e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69

import type { ConcreteRequest } from 'relay-runtime';
export type NotificationAction = "DONT_NOTIFY" | "NOTIFY" | "%future added value";
export type ContentMention = {
  mentionLocalId?: string | null;
  mentionedUserAccountId: string;
  notificationAction: NotificationAction;
};
export type useMentionNotificationMutationCreateContentMentionNotificationActionMutation$variables = {
  contentId: string;
  mentions: ReadonlyArray<ContentMention | null>;
};
export type useMentionNotificationMutationCreateContentMentionNotificationActionMutation$data = {
  readonly createContentMentionNotificationAction: {
    readonly contentId: string;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useMentionNotificationMutationCreateContentMentionNotificationActionMutation = {
  response: useMentionNotificationMutationCreateContentMentionNotificationActionMutation$data;
  variables: useMentionNotificationMutationCreateContentMentionNotificationActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mentions"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "mentions",
            "variableName": "mentions"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateContentMentionNotificationActionPayload",
    "kind": "LinkedField",
    "name": "createContentMentionNotificationAction",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "325893057a9ae854264a36ff297497e4",
    "id": "7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69",
    "metadata": {},
    "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
    "operationKind": "mutation",
    "text": "mutation useMentionNotificationMutationCreateContentMentionNotificationActionMutation($contentId:ID!,$mentions:[ContentMention]!){createContentMentionNotificationAction(input:{contentId:$contentId,mentions:$mentions}){contentId,success,errors{message}}}"
  }
};
})();

(node as any).hash = "d2cb21a69b28359ca54e883cea95094b";

export default node;
